export function Benefits() {
    const items = [
        { icon: "⏱️", title: "Gagnez du temps", desc: "Plus besoin de décrocher le téléphone. Les commandes arrivent directement, prêtes à préparer." },
        { icon: "💰", title: "Augmentez votre chiffre d'affaires", desc: "Vos clients commandent avant d'arriver. Résultat : plus de commandes, moins d'attente, plus de rotation." },
        { icon: "🎯", title: "Fidélisez vos clients", desc: "Carte de fidélité automatique, coupons, emails. Vos habitués reviennent et en parlent autour d'eux." },
        { icon: "📱", title: "Image professionnelle", desc: "Votre propre application avec votre logo et vos couleurs. Installable sur le téléphone comme une vraie app." },
        { icon: "🧾", title: "Moins d'erreurs", desc: "Le client compose sa commande lui-même. Plus de malentendu au téléphone ou de note illisible." },
        { icon: "📊", title: "Pilotez votre activité", desc: "Tableau de bord avec vos ventes, produits populaires, heures de pointe. Prenez les bonnes décisions." },
    ];

    return (
        <section className="py-12 px-6 bg-slate-50">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Pourquoi passer à la commande en ligne ?
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    Des avantages concrets pour votre activité, dès le premier jour.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[800px] mx-auto">
                {items.map(it => (
                    <div key={it.title} className="flex items-start gap-4 p-6 rounded-xl bg-white border border-slate-200 shadow-sm">
                        <div className="w-12 h-12 rounded-lg flex items-center justify-center text-[1.4rem] shrink-0 bg-orange-50">{it.icon}</div>
                        <div>
                            <h3 className="text-base font-bold text-slate-900 mb-1">{it.title}</h3>
                            <p className="text-[0.88rem] text-slate-500 leading-relaxed">{it.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
